// extracted by mini-css-extract-plugin
export default {"container":"Mfe_qgmZ","infoRows":"xz3wZuQY","relToTicket":"g8s7Ldg6","name":"psDM13dH","disabledName":"EIwIvh49","relToProject":"QPcijTD5"};